/**
 * 빌드 구성 플래그 — **빌드 때 굽는다**(CRA 가 `process.env.REACT_APP_*` 를 문자열로 바꿔 넣는다).
 *
 * AI_ENABLED — 스탠드얼론 「AI 제외」 빌드(옵션 2, `npm run electron:build:noai`)에서 false.
 * 그 빌드는 백엔드에서 LLM·도구 서버·PDF 전사 패키지를 빼므로 화면에서도 AI 진입점(에이전트 패널·AI 에게
 * 묻기·AI 설정·튜닝 사례·테이블 분석)을 감춘다. 안 감추면 버튼은 있는데 누르면 실패해 "고장 난 앱" 으로 보인다.
 * AI 가 아닌 기능(ERD 관계 추정·실행계획 부가 정보·사용 안내)은 같은 백엔드 라우터를 쓰지만 LLM 을 부르지 않아 그대로 둔다.
 * 구성 설명: docs/features/09-deployment.md 「스탠드얼론 빌드 옵션」
 */
export const AI_ENABLED = process.env.REACT_APP_NO_ASSISTANT !== 'true';

/**
 * IS_STANDALONE — Electron(스탠드얼론) 화면인가. **판정은 여기 한 곳**(2026-10-03). 예전에는 App·Header·ErrorBoundary·
 * FeedbackDialog·qbase.js 가 각자 `process.env.REACT_APP_STANDALONE` 을 읽어, 새 화면이 생길 때마다 웹 전용 UI(공유·
 * 티어·신고)가 스탠드얼론에 새어 나왔다. 빌드 플래그가 없는 개발 실행에서는 preload 가 심는 `window.electronAPI.isStandalone`
 * 으로도 알아본다. 혼자 쓰는 앱에서 뜻이 없는 것(사용자 간 공유·구독·조회 공유·티어 관리)은 이 값으로 감춘다.
 */
export const IS_STANDALONE = process.env.REACT_APP_STANDALONE === 'true'
  || !!(typeof window !== 'undefined' && window.electronAPI && window.electronAPI.isStandalone);
